/* Store build order builder: package + add-ons → live total and delivery estimate → cart → checkout. */
(function () {
  var form = document.querySelector('[data-hsb-order]');
  var dataEl = document.querySelector('[data-hsb-data]');
  if (!form || !dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  var linesEl = form.querySelector('[data-hsb-lines]');
  var totalEl = form.querySelector('[data-hsb-total]');
  var etaEl = form.querySelector('[data-hsb-eta]');
  var submit = form.querySelector('[data-hsb-submit]');
  var errEl = form.querySelector('[data-hsb-err]');
  var fastRow = form.querySelector('[data-hsb-addon="fast"]');
  var bar = document.querySelector('[data-hsb-bar]');
  var barName = bar && bar.querySelector('[data-hsb-bar-name]');
  var barTotal = bar && bar.querySelector('[data-hsb-bar-total]');

  function money(cents) {
    var amount = (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    return data.money.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  function pkgKey() {
    var r = form.querySelector('[data-hsb-pkg]:checked');
    return r ? r.getAttribute('data-hsb-pkg') : 'growth';
  }
  function fastFor(key) {
    var p = fastRow ? fastRow.getAttribute('data-fast-' + key).split(':') : null;
    return p ? { id: +p[0], price: +p[1], days: +p[2] } : null;
  }

  /* Current selection as cart lines + delivery days. */
  function selection() {
    var key = pkgKey();
    var pkg = data.packages[key];
    var items = [{ id: pkg.variant, quantity: 1, name: pkg.name, price: pkg.price }];
    var days = pkg.days;
    form.querySelectorAll('[data-hsb-addon]').forEach(function (row) {
      var name = row.getAttribute('data-hsb-addon');
      if (row.hidden) return;
      if (name === 'fast') {
        if (!row.querySelector('[data-hsb-toggle]').checked) return;
        var f = fastFor(key);
        items.push({ id: f.id, quantity: 1, name: data.addonNames.fast, price: f.price });
        days = f.days;
        return;
      }
      var qtyInput = row.querySelector('[data-hsb-qty]');
      var qty = qtyInput ? Math.max(0, Math.min(50, parseInt(qtyInput.value, 10) || 0)) : (row.querySelector('[data-hsb-toggle]').checked ? 1 : 0);
      if (!qty) return;
      items.push({ id: +row.getAttribute('data-variant'), quantity: qty, name: data.addonNames[name], price: +row.getAttribute('data-price') });
    });
    /* Fiverr-style: add-on time is added on top, except with extra-fast delivery which sets the date. */
    if (!items.some(function (i) { return i.name === data.addonNames.fast; })) {
      items.slice(1).forEach(function (i) {
        var k = Object.keys(data.addonNames).filter(function (n) { return data.addonNames[n] === i.name; })[0];
        days += (data.addonDays[k] || 0) * i.quantity;
      });
    }
    return { items: items, days: days };
  }

  function render() {
    var key = pkgKey();
    form.querySelectorAll('[data-only]').forEach(function (row) {
      var show = row.getAttribute('data-only').split(' ').indexOf(key) !== -1;
      row.hidden = !show;
      if (!show) row.querySelector('[data-hsb-toggle]').checked = false;
    });
    if (fastRow) {
      var f = fastFor(key);
      fastRow.querySelector('[data-hsb-fast-label]').textContent = money(f.price) + ' · delivered in ' + f.days + ' days instead of ' + data.packages[key].days;
    }
    var sel = selection();
    var total = 0;
    linesEl.innerHTML = '';
    sel.items.forEach(function (i) {
      total += i.price * i.quantity;
      var li = document.createElement('li');
      var n = document.createElement('span');
      n.textContent = i.name + (i.quantity > 1 ? ' × ' + i.quantity : '');
      var p = document.createElement('b');
      p.textContent = money(i.price * i.quantity);
      li.append(n, p);
      linesEl.appendChild(li);
    });
    if (totalEl.textContent !== money(total)) {
      totalEl.textContent = money(total);
      totalEl.classList.remove('is-bump'); void totalEl.offsetWidth; totalEl.classList.add('is-bump');
    }
    etaEl.textContent = sel.days + ' days';
    if (barName) { barName.textContent = data.packages[key].name; barTotal.textContent = money(total); }
  }

  form.addEventListener('change', render);
  form.addEventListener('input', function (e) { if (e.target.matches('[data-hsb-qty]')) render(); });
  form.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hsb-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('[data-hsb-qty]');
    input.value = Math.max(0, Math.min(50, (parseInt(input.value, 10) || 0) + +b.getAttribute('data-hsb-step')));
    render();
  });

  /* Replace any earlier store-build lines (e.g. after pressing Back from checkout), then add this order and go to checkout. */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var sel = selection();
    submit.disabled = true;
    submit.classList.add('is-busy');
    errEl.hidden = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (i) { if (data.productIds.indexOf(i.product_id) !== -1) updates[i.key] = 0; });
        if (!Object.keys(updates).length) return;
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
      })
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          /* Reversed: the cart lists the newest line first, so the package ends up on top. */
          body: JSON.stringify({ items: sel.items.map(function (i) { return { id: i.id, quantity: i.quantity }; }).reverse() })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        submit.disabled = false;
        submit.classList.remove('is-busy');
        errEl.hidden = false;
      });
  });

  /* Phones: tapping a package card scrolls it into the middle of the swipe row. */
  var pkgs = form.querySelector('[data-hsb-pkgs]');
  form.addEventListener('change', function (e) {
    if (!e.target.matches('[data-hsb-pkg]') || !pkgs || pkgs.scrollWidth <= pkgs.clientWidth) return;
    var card = e.target.closest('.hsb-pkg');
    pkgs.scrollTo({ left: card.offsetLeft - (pkgs.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
  });
  if (pkgs && pkgs.scrollWidth > pkgs.clientWidth) {
    var pop = pkgs.querySelector('.hsb-pkg--pop');
    if (pop) pkgs.scrollLeft = pop.offsetLeft - (pkgs.clientWidth - pop.offsetWidth) / 2;
  }

  /* Sticky order bar (phones): shown once the hero is passed, hidden while the order summary is on screen. */
  if (bar && 'IntersectionObserver' in window) {
    var hero = document.querySelector('.hsb-hero');
    var sum = document.querySelector('[data-hsb-sum]');
    var pastHero = false, sumVisible = false;
    var sync = function () {
      var show = pastHero && !sumVisible;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelector('[data-hsb-bar-go]').tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; sync(); }).observe(hero);
    new IntersectionObserver(function (en) { sumVisible = en[0].isIntersecting; sync(); }).observe(sum);
    bar.querySelector('[data-hsb-bar-go]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else submit.click();
    });
  }

  render();
})();

/* Motion: reveal on scroll and count-up stats. Skipped for reduced motion. */
(function () {
  var root = document.querySelector('.hsb');
  if (!root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('hsb--anim');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var groups = ['.hsb-sec .hsb-kicker, .hsb-sec .hsb-h2, .hsb-sec .hsb-sub, .hsb-revsum', '.hsb-feat', '.hsb-pkg', '.hsb-addons, .hsb-sum', '.hsb-steps li', '.hsb-work__card', '.hsb-rev', '.hsb-fit__col', '.hsb-faq details', '.hsb-final__inner > *'];
  groups.forEach(function (sel) {
    root.querySelectorAll(sel).forEach(function (el, i) {
      el.classList.add('hsb-reveal');
      el.style.setProperty('--d', (i % 6) * 70 + 'ms');
      io.observe(el);
    });
  });

  var counts = root.querySelectorAll('[data-hsb-count]');
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, end = parseFloat(el.getAttribute('data-hsb-count')), dec = +el.getAttribute('data-dec') || 0, t0 = performance.now();
      (function tick(now) {
        var k = Math.min(1, (now - t0) / 1400), v = end * (1 - Math.pow(1 - k, 3));
        el.textContent = v.toFixed(dec);
        if (k < 1) requestAnimationFrame(tick);
      })(t0);
    });
  }, { threshold: .6 });
  counts.forEach(function (el) { el.textContent = (0).toFixed(+el.getAttribute('data-dec') || 0); cio.observe(el); });
})();
